// extracted by mini-css-extract-plugin
module.exports = {"shareFeedbackContainer":"shareFeedback_shareFeedbackContainer__OcrhH","feedbackTitle":"shareFeedback_feedbackTitle__CUndd"};